import { vsModuleName as mealLogModuleName } from "../../../machines.mealLog";

import angular from "angular";

export const vsModuleName = "SlotTrak.Machines.MealLog.CacheCreek";

angular.module(vsModuleName, [mealLogModuleName]);
